import React from "react";
import { companyLogoUrl } from "@/lib/erp";

// Branded header that appears ONLY when printing a report/statement.
export default function PrintBrandHeader({ company, title, subtitle }) {
  const c = company || {};
  const logo = c.print_show_logo !== false ? companyLogoUrl(c) : null;
  return (
    <div className="hidden print:flex items-start justify-between border-b-2 border-slate-800 pb-3 mb-4" data-testid="print-brand-header">
      <div className="flex items-center gap-3">
        {logo && <img src={logo} alt="" style={{ maxHeight: "48px", maxWidth: "180px", objectFit: "contain" }} />}
        <div>
          <div className="font-heading text-lg font-bold">{c.name}</div>
          {c.address && <div className="text-[11px] text-slate-600 max-w-xs">{c.address}</div>}
          {c.gstin && <div className="text-[11px] text-slate-600">GSTIN: {c.gstin}</div>}
        </div>
      </div>
      <div className="text-right">
        {title && <div className="font-heading font-bold">{title}</div>}
        {subtitle && <div className="text-[11px] text-slate-600">{subtitle}</div>}
        <div className="text-[10px] text-slate-500">Generated {new Date().toLocaleDateString()}</div>
      </div>
    </div>
  );
}
